var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasFeature("FEATURE_REFERRAL") &&
    !!_vm.isLoggedIn &&
    _vm.accountReferralUrl
    ? _c(
        "div",
        { staticClass: "account__block insicht insicht--fade-up" },
        [
          _c("h2", {
            staticClass: "account__block-title",
            domProps: { innerHTML: _vm._s(_vm.$t("account.referral.title")) }
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "account__block-text",
            domProps: { innerHTML: _vm._s(_vm.$t("account.referral.text")) }
          }),
          _vm._v(" "),
          _vm.$te("account.referral.infoLinkText") &&
          _vm.$te("account.referral.infoLinkUrl")
            ? _c("Button", {
                attrs: {
                  type: "button",
                  href: _vm.$t("account.referral.infoLinkUrl"),
                  text: _vm.$t("account.referral.infoLinkText"),
                  level: "tertiary",
                  arrow: ""
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("input", {
            staticClass: "account__referral-token",
            attrs: { readonly: "" },
            domProps: { value: _vm.accountReferralUrl },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.onReferralTokenClick.apply(null, arguments)
              }
            }
          }),
          _vm._v(" "),
          _c("ShareButtons", {
            staticClass: "account__referral-buttons",
            attrs: {
              url: _vm.accountReferralUrl,
              "email-subject": _vm.emailSubject,
              "email-text": _vm.emailText,
              "whatsapp-text": _vm.whatsappText,
              "facebook-text": _vm.facebookText,
              "twitter-text": _vm.twitterText
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }